/*
    Stable identity of a marketplace app, mirroring CrqlarAppsSKU on the API side.

    An OrganizationApp's `name` is a free-text label the customer may rename at will,
    so it must never be used to identify an app in code. Match on the SKU of the
    linked App instead.
 */
export var AppSku = {
    CORRESPONDENCE: 'correspondence',
    BOOKING_ENGINE: 'booking',
    CRM: 'crm',
    MARKETING: 'marketing',
    RESERVATIONS: 'reservations',
    SURVEYS: 'surveys',
    VOICE_NOTE: 'voiceNote',
    PMS_ELITE: 'elite',
    PMS_CASABLANCA: 'casablanca',
    PMS_FIDELIO: 'fidelio',
    PMS_PROTEL: 'protel',
    PMS_GASTRODAT: 'gastrodat',
    PMS_ASA: 'asa',
    PMS_OHIP: 'ohip',
    PMS_CRQLAR_V2: 'crqlarV2',
    PMS_MEWS: 'mews',
    PMS_INCERT: 'incert',
    PMS_APALEO: 'apaleo',
    STRIPE: 'stripe',
    HOBEX: 'hobex',
    INTERALP: 'interalp',
    FIAS: 'fias',
};
/*
    Specializations of the `reservations` SKU - one SKU, several sector flavours.
 */
export var AppSpecialization = {
    SPA: 'spa',
    RESTAURANT: 'restaurant',
    ACCOMMODATION: 'accommodation',
    OTHER: 'other',
    WEEKLY_PLANNER: 'weekly-planner',
};
